import { Modal } from "antd";
import { Box, Text } from "@chakra-ui/react";

interface ModalTermosProps {
  termos: string;
  isOpen: boolean;
  onClose: () => any;
}

function ModalTermos({ termos, isOpen, onClose }: ModalTermosProps) {
  return (
    <Modal
      width="800px"
      centered
      className="ant-modal-rounded"
      bodyStyle={{
        height: "max(60vh, 400px)",
        overflow: "auto",
        paddingBottom: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
      title="Termos de uso"
      footer={null}
    >
      <Box>
        <Text>{termos}</Text>
      </Box>
    </Modal>
  );
}

export default ModalTermos;
